<template>
	<div>
		<app-inbox-loading v-if="isDataLoading" />
		<div v-else>
			<b-row>
				<b-col v-if="false">
					<b-button class="btn-close-page float-right mb-2" @click="$emit('closePage')" v-b-tooltip.hover title="Close"><b-icon-x /></b-button>
					<b-button class="btn-close-page float-right mb-2 mr-2" @click="$emit('approvalFlow')" v-b-tooltip.hover title="Approval History"><b-icon icon="clock-history" /></b-button>
				</b-col>
			</b-row>
			<b-card header="Production Quality Inspection Dimension" class="mb-3">
				<b-row>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Production Quality Inspection Number" :model="model.productionQualityInspectionNumber" />
						<app-input-combobox-autocomplete :options="workOrderProcesss" optionsLabel="workOrderProcessNumber" optionsKey="id" label-cols-lg="12" label="Work Order Process" id="fieldset-work-order-process" size="sm" :model.sync="model.workOrderProcessId"   :selected="model.workOrderProcess != null ? model.workOrderProcess.workOrderProcessNumber : ''" @input="getWorkOrderProcesss" @change="updateData" :isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderProcess" :isUpdatable="true"/>
						<app-input-datepicker id="fieldset-production-date" label-cols-lg="12" label="Production Date" size="sm" :model.sync="model.productionDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="false" :isUpdatable="true" />
					</b-col>
					<b-col cols="12" lg="6">
					</b-col>
				</b-row>
			</b-card>

		<app-table-input-popup title="Production Quality Inspection Dimension Detail" :bordered="true" :items="productionQualityInspectionDimensionDetails" :fields="fieldsProductionQualityInspectionDimensionDetail" :busy="isDataLoading" :sort-by.sync="sortByProductionQualityInspectionDimensionDetail" :sort-desc.sync="sortDescProductionQualityInspectionDimensionDetail" small responsive
			@editButtonMethod="editRowDataProductionQualityInspectionDimensionDetail"
			@deleteButtonMethod="deleteRowDataProductionQualityInspectionDimensionDetail"
			@showPopupAddMethod="resetDataProductionQualityInspectionDimensionDetail()"
			@showPopupUploadMethod="showPopupUploadProductionQualityInspectionDimensionDetail()"
			@downloadMethod="downloadProductionQualityInspectionDimensionDetail()"
			@addFromClipboardMethod="addFromClipboardProductionQualityInspectionDimensionDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardProductionQualityInspectionDimensionDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadProductionQualityInspectionDimensionDetail"
			>
			<template #top-row v-if="isShowProductionQualityInspectionDimensionDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
							<b-th stacked-heading="Part Number">
								<v-select append-to-body label="partNumber" :options="parts"  :value="filterProductionQualityInspectionDimensionDetail.partId" :reduce="item => item.id" v-model="filterProductionQualityInspectionDimensionDetail.partId" @search="getParts" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Is Checked">
								<b-form-checkbox id="input-is-checked-table" class="float-right" v-model="filterProductionQualityInspectionDimensionDetail.isChecked"></b-form-checkbox>
							</b-th>
							<b-th stacked-heading="Attachment">
							</b-th>
							<b-th stacked-heading="Remark">
								<b-form-input id="input-remark-table" v-model="filterProductionQualityInspectionDimensionDetail.remark" size="sm"></b-form-input>
							</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( productionQualityInspectionDimensionDetailPageSize * (currentProductionQualityInspectionDimensionDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(part)="row">
									<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-production-quality-inspection-dimension-detail-part-' + row.index" label-cols-lg="12" label="Part Number" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputProductionQualityInspectionDimensionDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isEditable="false"   :nolabel="true"  />
								</template>
								<template v-slot:cell(partName)="row">
											<app-input-textbox label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null" :isEditable="false" />
								</template>
								<template v-slot:cell(customer)="row">
											<app-input-textbox label-cols-lg="12" size="sm" label="Customer" :model="(row.item.part != null) ? (row.item.part.customer != null) ? row.item.part.customer.code : null : null" :isEditable="false" />
								</template>
								<template v-slot:cell(isChecked)="row">
									<app-input-checkbox :id="'input-production-quality-inspection-dimension-detail-is-checked-row-' + row.index" label-cols-lg="12" label="Is Checked" :model.sync="row.item.isChecked" @change="saveInputProductionQualityInspectionDimensionDetail(row.item)" :isEditable="false"   :nolabel="true" ></app-input-checkbox>
								</template>
								<template v-slot:cell(attachment)="row">
									<app-input-fileupload :id="'input-production-quality-inspection-dimension-detail-attachment-' + row.index" label-cols-lg="12" label="Attachment" size="sm" :model.sync="attachments[row.item.id]" :currentModel="row.item.attachment" @change="saveInputProductionQualityInspectionDimensionDetail(row.item)" :isEditable="false" :isUpdatable="true"  :nolabel="true" />
								</template>
								<template v-slot:cell(remark)="row">
									<app-input-textarea :id="'input-production-quality-inspection-dimension-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputProductionQualityInspectionDimensionDetail(row.item)" :isEditable="false"   :nolabel="true"  />
								</template>

			<template v-slot:form-add-detail>
				<ProductionQualityInspectionDimensionDetailInput 
					:openPopup="isShowPopupProductionQualityInspectionDimensionDetail"
					:modelId="productionQualityInspectionDimensionDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataProductionQualityInspectionDimensionDetail"/>
			</template>
			<template v-slot:upload-detail>
				<ProductionQualityInspectionDimensionDetailUpload
					:openPopup="isShowPopupUploadProductionQualityInspectionDimensionDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataProductionQualityInspectionDimensionDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-production-quality-inspection-dimension-detail-part-' + row.index" label-cols-lg="12" label="Part Number" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputProductionQualityInspectionDimensionDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isEditable="false" :nolabel="true"  />
					<app-input-textbox label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null" :isEditable="false"   />
					<app-input-textbox label-cols-lg="12" size="sm" label="Customer" :model="(row.item.part != null) ? (row.item.part.customer != null) ? row.item.part.customer.code : null : null" :isEditable="false"   />
					<app-input-checkbox :id="'input-production-quality-inspection-dimension-detail-is-checked-row-' + row.index" label-cols-lg="12" label="Is Checked" :model.sync="row.item.isChecked" @change="saveInputProductionQualityInspectionDimensionDetail(row.item)" :isEditable="false" :nolabel="true" ></app-input-checkbox>
					<app-input-fileupload :id="'input-production-quality-inspection-dimension-detail-attachment-' + row.index" label-cols-lg="12" label="Attachment" size="sm" :model.sync="attachments[row.item.id]" :currentModel="row.item.attachment" @change="saveInputProductionQualityInspectionDimensionDetail(row.item)" :isEditable="false" :isUpdatable="true" :nolabel="true" />
					<app-input-textarea :id="'input-production-quality-inspection-dimension-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputProductionQualityInspectionDimensionDetail(row.item)" :isEditable="false" :nolabel="true"  />
				</b-card>
			</template>

		</app-table-input-popup>
			<b-overlay :show="isBusy" no-wrap></b-overlay>
			<Portal to="app-inbox-button">
				<app-approval-button
					@approveMethod="editRequestAction" 
					:showApproveButton="false" 
					approveButtonTitle="Edit Request"
					:showRejectButton="false"
					:showRevisionButton="false"
					/>
			</Portal>
		</div>
	</div>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProductionQualityInspectionDimension from '@/models/ProductionQualityInspectionDimension/ProductionQualityInspectionDimension';
import ProductionQualityInspectionDimensionList from '@/models/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionList';
import ProductionQualityInspectionDimensionFilter from '@/filters/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionFilter';

import AppInputTextarea from '@/components/AppInputTextarea';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import ProductionQualityInspectionDimensionDetail from '@/models/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionDetail';
import ProductionQualityInspectionDimensionDetailFilter from '@/filters/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import AppInputFileupload from '@/components/AppInputFileupload';
import Attachment from '@/models/Core/Attachment';
import AttachmentFilter from '@/filters/Core/AttachmentFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import ProductionQualityInspectionDimensionDetailInput from '@/views/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionDetailInput';
import ProductionQualityInspectionDimensionDetailUpload from '@/views/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionDetailUpload';

import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import AppApprovalButton from '@/components/AppApprovalButton';
import AppInputTextbox from '@/components/AppInputTextbox';

export default {
	props: 
		{
			selectedModelId: {
				default: "",
				type: String
			},
			selectedModel: {
				default: null,
				type: Object
			},
			successAction: {},
			inboxType: {
				default: "",
				type: String
			}
		}
	,
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatetimepickerRange,
		AppInputCheckbox,
		AppInputFileupload,
		ProductionQualityInspectionDimensionDetailInput,
		ProductionQualityInspectionDimensionDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail, 
		PopupRouterView,
		AppApprovalButton,
		AppInputTextarea,
		AppInputTextbox,

		PopupRouterViewApprovalDetail, 
		PopupRouterViewDetail,
		PopupRouterView,
		AppApprovalButton,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},

	data() {
		return {
			errorMessage : {
			},

			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			isShowDataDetailFilter: false,
			isDownloadDataDetail: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			backroute: '',
			approvalConfiguration: {},
			fieldsProductionQualityInspectionDimensionDetail: [
				//{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"part": { "class" : "th-part first-child", "label" : "Part Number", key: 'part', sortable: false }}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false }}, 
				{"customer": { "class" : "th-customer last-child", "label" : "Customer", key: 'customer', sortable: false }}, 
				{"isChecked": { "class" : "th-is-checked d-stack-none", "label" : "Is Checked", key: 'isChecked', sortable: false }}, 
				{"attachment": { "class" : "th-attachment d-stack-none", "label" : "Attachment", key: 'attachment', sortable: false }}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: false }}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			modelProductionQualityInspectionDimensionDetail : {},
			isShowPopupProductionQualityInspectionDimensionDetail : false,
			isShowPopupUploadProductionQualityInspectionDimensionDetail : false,
			filterProductionQualityInspectionDimension : null,
			currentProductionQualityInspectionDimensionPage : 1,
			productionQualityInspectionDimensionPageSize: 10,
			sortByProductionQualityInspectionDimension: '',
			sortDescProductionQualityInspectionDimension: '',
			filterProductionQualityInspectionDimensionDetail : null,
			currentProductionQualityInspectionDimensionDetailPage : 1,
			productionQualityInspectionDimensionDetailPageSize: 10,
			sortByProductionQualityInspectionDimensionDetail: '',
			sortDescProductionQualityInspectionDimensionDetail: '',
			sortingByProductionQualityInspectionDimensionDetail: [],
			productionQualityInspectionDimensionDetails : [],
			productionQualityInspectionDimensionDetailId : '',
			totalProductionQualityInspectionDimensionDetailRow : 0,
			isShowProductionQualityInspectionDimensionDetailFilter: false,
			isDownloadProductionQualityInspectionDimensionDetail: false,
			parts: [],
			attachments: [],
			workOrderProcesss: [],
			workOrderProcesss: [],
			isWorkOrderProcessComboLoading: false,
			backroute: '',
			isWorkOrderProcessComboLoading: false,
			isProductionQualityInspectionDimensionComboLoading: false,
			isPartComboLoading: false,
			isAttachmentComboLoading: false,

		}
	},
	methods : {
		getProductionQualityInspectionDimension : async function(id) {
			this.isDataLoading = true;
			this.getProductionQualityInspectionDimensionDetails();

			
			ProductionQualityInspectionDimension.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				//ProductionQualityInspectionDimension.getApprovalConfigurationInput(this, result.approvalInstanceId).then(result => { this.approvalConfiguration = result; this.isDataLoading = false; }).catch(() => { this.isDataLoading = false; });
				this.isDataLoading = false;
			}).catch(error => { this.isDataLoading = false; });
		},
		downloadData() {
			this.isDownloadProductionQualityInspectionDimension = true;
			this.filterProductionQualityInspectionDimension.id = this.modelId;
			ProductionQualityInspectionDimension.downloadDataDetail(this, this.filterProductionQualityInspectionDimension).then(result => {
				this.isDownloadProductionQualityInspectionDimension = false;
			}).catch(error => { this.isDownloadProductionQualityInspectionDimension = false; })
		},
		getProductionQualityInspectionDimensionDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterProductionQualityInspectionDimensionDetail);
			if (this.modelId == null) return;
			filter.productionQualityInspectionDimensionId = this.modelId;
			//filter.draftMode = "0";
			if (this.sortByProductionQualityInspectionDimensionDetail != null) {
				this.sortingByProductionQualityInspectionDimensionDetail[this.sortByProductionQualityInspectionDimensionDetail] = this.sortDescProductionQualityInspectionDimensionDetail;
			}
			let currentPage = (this.currentProductionQualityInspectionDimensionDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalProductionQualityInspectionDimensionDetailRow + 1;
				let page = Math.ceil(totalData/this.productionQualityInspectionDimensionDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.productionQualityInspectionDimensionDetailPageSize = 0;
			// disable paging end
			ProductionQualityInspectionDimensionDetail.getList(this, filter, this.sortingByProductionQualityInspectionDimensionDetail, currentPage , this.productionQualityInspectionDimensionDetailPageSize).then(result => {
				this.currentProductionQualityInspectionDimensionDetailPage = currentPage + 1;
				this.productionQualityInspectionDimensionDetails = result.data;
				this.totalProductionQualityInspectionDimensionDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getProductionQualityInspectionDimensions : async function(input) {
			let filter = new ProductionQualityInspectionDimensionFilter();
			if (input != undefined) {
				filter.workOrderProcess = input;
			}
			this.isProductionQualityInspectionDimensionComboLoading = true;
			ProductionQualityInspectionDimension.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionQualityInspectionDimensions = result.data
				}
				this.isProductionQualityInspectionDimensionComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getAttachments : async function(input) {
			let filter = new AttachmentFilter();
			if (input != undefined) {
				filter.originalFilename = input;
			}
			this.isAttachmentComboLoading = true;
			Attachment.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.attachments = result.data
				}
				this.isAttachmentComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcess(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessId = null;
				this.model.workOrderProcess = null;
			} else {
				this.model.workOrderProcessId = item.id;
				this.model.workOrderProcess = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ProductionQualityInspectionDimension.updateData(this, model, id);
				}
			});
		},

		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ProductionQualityInspectionDimension.updateData(this, model, id);
				}
			});
		},
		editDraftAction(modelEvent) {
			let id = this.modelId;
			if(id != '' && id != null && id != undefined) {
				this.$router.push({ name: 'productionqualityinspectiondimensioncreateinboxrequest', params : { id: id } });
			}
		},
		submitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				ProductionQualityInspectionDimension.submitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		approveAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to approve this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							ProductionQualityInspectionDimension.approveApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		rejectAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to reject this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							ProductionQualityInspectionDimension.rejectApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		reviseAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to ask for revision for this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							ProductionQualityInspectionDimension.reviseApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		editRequestAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				ProductionQualityInspectionDimension.editRequest(this, id).then(result => {
					if (result != null) {
						if (result.id != null && result.id != "") {
							this.$router.push({ name: 'productionqualityinspectiondimensioncreateinboxrequest', params : { id: result.id } });
						}
					}
					this.isCreateBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		discardAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to discard this data?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						ProductionQualityInspectionDimension.discardData(this, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				ProductionQualityInspectionDimension.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		cancelAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to cancel this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						ProductionQualityInspectionDimension.cancelApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		onHidden() {
			// this.getProductionQualityInspectionDimensions();
		},
		addRowDataProductionQualityInspectionDimensionDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.productionQualityInspectionDimensionId =  this.modelId;
					ProductionQualityInspectionDimensionDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getProductionQualityInspectionDimensionDetails(true);
						this.isShowPopupProductionQualityInspectionDimensionDetail = false;
					})
				} else {
					model.productionQualityInspectionDimensionId =  this.modelId;
					ProductionQualityInspectionDimensionDetail.createData(this, model)
					.then(result => {
						this.getProductionQualityInspectionDimensionDetails(true);
						this.isShowPopupProductionQualityInspectionDimensionDetail = false;
					})
				}
			}
		},
		async editRowDataProductionQualityInspectionDimensionDetail(id) {
			this.productionQualityInspectionDimensionDetailId = id;
			this.isShowPopupProductionQualityInspectionDimensionDetail = true; 
		},
		async deleteRowDataProductionQualityInspectionDimensionDetail(id) {
			ProductionQualityInspectionDimensionDetail.deleteData(this, id).then(result => { this.getProductionQualityInspectionDimensionDetails(); });
		},
		async resetDataProductionQualityInspectionDimensionDetail() {
			this.productionQualityInspectionDimensionDetailId = "";
			this.isShowPopupProductionQualityInspectionDimensionDetail = true;
		},
		async addDataProductionQualityInspectionDimensionDetail() {
			ProductionQualityInspectionDimensionDetail.createData(this, { productionQualityInspectionDimensionId: this.modelId })
			.then(result => {
				this.getProductionQualityInspectionDimensionDetails(true);
			})
		},
		async addFromClipboardProductionQualityInspectionDimensionDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, productionQualityInspectionDimensionId: this.modelId });
				});
				ProductionQualityInspectionDimensionDetail.addFromClipboard(this, parts).then(result => { this.getProductionQualityInspectionDimensionDetails() });
			});
		},
		async replaceFromClipboardProductionQualityInspectionDimensionDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, productionQualityInspectionDimensionId: this.modelId });
				});
				ProductionQualityInspectionDimensionDetail.replaceFromClipboard(this, parts).then(result => { this.getProductionQualityInspectionDimensionDetails() });
			});   
		},
		showPopupUploadProductionQualityInspectionDimensionDetail() {
			this.isShowPopupUploadProductionQualityInspectionDimensionDetail = true;
		},
		uploadDataProductionQualityInspectionDimensionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadProductionQualityInspectionDimensionDetail = false; 
		},
		downloadProductionQualityInspectionDimensionDetail(modalEvent) {
			this.isDownloadProductionQualityInspectionDimensionDetail = true;
			this.filterProductionQualityInspectionDimensionDetail.productionQualityInspectionDimensionId = this.modelId;
			ProductionQualityInspectionDimensionDetail.downloadDataDetail(this, this.filterProductionQualityInspectionDimensionDetail).then(result => {
				this.isDownloadProductionQualityInspectionDimensionDetail = false;
			}).catch(error => { this.isDownloadProductionQualityInspectionDimensionDetail = false; })
		},
		saveInputProductionQualityInspectionDimensionDetail(item) {
			ProductionQualityInspectionDimensionDetail.updateDataDetail(this, item, item.id);
		},

		resetModal(modalType) {
			this.isShowPopupUploadProductionQualityInspectionDimensionDetail = false; 
			this.isShowPopupProductionQualityInspectionDimensionDetail = false; 
			if (modalType == 'ProductionQualityInspectionDimensionDetail') {
				this.getProductionQualityInspectionDimensionDetails();
			}

			//this.showPopupCopyData = false; 
			//this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowProductionQualityInspectionDimensionDetailFilter = true;

			}
		},
	},
	beforeMount() {
		//this.filterProductionQualityInspectionDimension = new ProductionQualityInspectionDimensionFilter();
//this.filterProductionQualityInspectionDimension = new ProductionQualityInspectionDimensionFilter();
		this.filterProductionQualityInspectionDimensionDetail = new ProductionQualityInspectionDimensionDetailFilter();
		//this.getProductionQualityInspectionDimensions();
		//this.getParts();
		//this.getWorkOrderProcesss();


		//this.getProductionQualityInspectionDimensions();
	},
	async mounted() {
		if (this.selectedModel != null && this.selectedModel != "") {
			this.modelId = this.selectedModel.id;
			this.model = this.selectedModel;
			this.getDataDetails();
		} else if (this.selectedModelId != null && this.selectedModelId != "") {
			this.modelId = this.selectedModelId;
			this.getProductionQualityInspectionDimension(this.selectedModelId);
		}
	},
	computed: {
		disableRejectRevise() {
			if (this.model.approvalRemarks == undefined || this.model.approvalRemarks == null || this.model.approvalRemarks == '') return true;
			return false;
		},
	},
	watch : {
		selectedModelId(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue;
				this.getProductionQualityInspectionDimension(newValue);
			}
		},
		selectedModel(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue.id;
				this.model = newValue;
				this.getProductionQualityInspectionDimensionDetails();
			}
		},
		sortByProductionQualityInspectionDimensionDetail : {
			handler: function() {
				this.getProductionQualityInspectionDimensionDetails();
			}
		},
		sortDescProductionQualityInspectionDimensionDetail: {
			handler: function() {
				this.getProductionQualityInspectionDimensionDetails();
			}
		},
		currentProductionQualityInspectionDimensionDetailPage: {
			handler: function() {
				this.getProductionQualityInspectionDimensionDetails();
			}
		},
		productionQualityInspectionDimensionDetailPageSize : {
			handler: function() {
				this.getProductionQualityInspectionDimensionDetails();
			}
		},
		filterProductionQualityInspectionDimensionDetail: {
			handler: function() {
				this.getProductionQualityInspectionDimensionDetails();
			},
			deep: true,
		},


	},
}
</script>
